var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg404Sands2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1400 700",
    id: "svg21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs5"
  }, /*#__PURE__*/React.createElement("filter", {
    id: "filter240538",
    x: -0.07132194,
    y: -0.55249288,
    width: 1.1426439,
    height: 2.1049858,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 44.926879,
    id: "feGaussianBlur2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g17"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -63.64,
    y: 451.13,
    width: 1511.8,
    height: 195.16,
    fill: "#fedec2",
    filter: "url(#filter240538)",
    opacity: 0.78369,
    style: {
      mixBlendMode: "normal"
    },
    id: "rect7"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeDashoffset: 45,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    id: "g15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1400 577.61c-44.05 7.5539-87.164 25.116-129.97 20.435-291.81-31.913-522.66 1.1755-761.98-22.148-162.17-15.804-336.78 27.066-508.05 1.7127v122.39h1400z",
    fill: "#fead67",
    id: "path9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 577.61c466.67 0 933.33 81.513 1400 0v122.39h-1400z",
    fill: "#fed1aa",
    id: "path11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1400 577.61c-466.67 0-933.33 81.513-1400 0v122.39h1400z",
    fill: "#fec08a",
    id: "path13"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Sands2);
export default __webpack_public_path__ + "static/media/404sands2.5a0e2f4084844b9c842c91a4efd7670b.svg";
export { ForwardRef as ReactComponent };